module.exports = __webpack_public_path__ + "media/images/favicons/favicon-192x192-eb97f8d4e5b2ac7f8db37298021263da.png";